import React from "react";
import { useClient } from "../../shared/hooks/client-hook";
import { MathUtils } from "three";
import { db, storage } from "../../shared/hooks/firebase";
import { toast } from "react-toastify";

const Tabs = () => {
  const { editor, currentTool, setCurrentTool } = useClient();

  const tabs = {
    scene: {
      id: "scene",
      name: "Scene",
      icon: "/img/icons/scene.png",
    },
  };

  if (!editor) {
    return null;
  }

  function addTab() {
    const name = prompt("Enter tab name");

    if (!name) {
      return;
    }

    const tabToast = toast("Adding tab...", {
      type: "info",
      autoClose: false,
      closeButton: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });

    const id = MathUtils.generateUUID();

    //open file input to get an image

    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const dataUrl = event.target.result;
        const img = document.createElement("img");
        img.src = dataUrl;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          //resize image to 200x200
          canvas.width = 200;
          canvas.height = 200;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, 200, 200);
          const data = canvas.toDataURL("image/png");

          //upload image to firebase storage under assets/images/tabs/id.png

          storage
            .ref("assets/images/tabs")
            .child(id + ".png")
            .putString(data, "data_url")
            .then((snapshot) => {
              storage
                .ref(snapshot.ref.fullPath)
                .getDownloadURL()
                .then((url) => {
                  const tab = {
                    id,
                    name,
                    icon: url,
                  };

                  const newTabs = { ...editor.modelTabs, [id]: tab };

                  db.ref("/editor/modelTabs").set(newTabs);

                  toast.update(tabToast, {
                    type: "success",
                    message: "Tab added!",
                    autoClose: 2000,
                    closeOnClick: true,
                  });
                });
            });
        };
      };

      reader.readAsDataURL(file);
    };

    fileInput.click();
  }

  return (
    <div className="bg-gray-300 w-[55px]">
      {Object.keys(tabs).map((tabId) => {
        const tab = tabs[tabId];
        const { icon } = tab;
        return (
          <div
            key={tab.id}
            onClick={() => {
              setCurrentTool(tab.id);
            }}
            className={`relative group transition-all flex items-center mx-auto w-[55px] text-center h-[55px] border border-1 border-gray-400 border-l-0 ${
              tab.id === currentTool
                ? "bg-gray-50 text-blue-500 group-hover:text-blue-300"
                : "bg-gray-200 group-hover:bg-gray-100 text-black group-hover:text-blue-500"
            } rounded-r-lg mr-1 my-1 cursor-pointer`}
          >
            {icon && (
              <img
                src={icon}
                alt="model"
                className=" transition-all w-6 h-6 mx-auto group-hover:w-7 group-hover:h-7"
              />
            )}
          </div>
        );
      })}
      {editor.modelTabs &&
        Object.values(editor.modelTabs).map((tab, index) => {
          const { icon } = tab;

          return (
            <div
              key={index}
              onClick={() => {
                setCurrentTool(tab.id);
              }}
              className={`relative group transition-all flex items-center mx-auto w-[55px] text-center h-[55px] border border-1 border-gray-400 border-l-0 ${
                tab.id === currentTool
                  ? "bg-gray-50 text-blue-500 group-hover:text-blue-300"
                  : "bg-gray-200 group-hover:bg-gray-100 text-black group-hover:text-blue-500"
              } rounded-r-lg mr-1 my-1 cursor-pointer`}
            >
              {icon && (
                <img
                  src={icon}
                  alt="model"
                  className=" transition-all w-6 h-6 mx-auto group-hover:w-7 group-hover:h-7"
                />
              )}
            </div>
          );
        })}

      <div
        onClick={() => {
          addTab();
        }}
        className={`relative group transition-all flex items-center mx-auto w-[55px] text-center h-[55px] border border-1 border-gray-400 border-l-0 bg-gray-200 group-hover:bg-gray-100 text-black group-hover:text-blue-500 rounded-r-lg mr-1 my-1 cursor-pointer`}
      >
        <img
          src={"/img/icons/plus.png"}
          alt="model"
          className=" transition-all w-6 h-6 mx-auto group-hover:w-7 group-hover:h-7"
        />
      </div>
    </div>
  );
};

export default Tabs;
